import * as yup from 'yup'

export const requiredFieldNames = [
  'classCreationGoalValue',
  'classCreationGoalDate',
  'lessonCompletionGoalValue',
  'lessonCompletionGoalDate',
]

export const optionalFieldNames = [
  'goal3Date',
  'goal3Text',
  'goal4Date',
  'goal4Text',
  'goal5Date',
  'goal5Text',
]

export const fieldNames = requiredFieldNames.concat(optionalFieldNames)

export const additionalGoalFields = [
  {
    date: 'goal3Date',
    text: 'goal3Text',
    show: 'showGoal3',
  },
  {
    date: 'goal4Date',
    text: 'goal4Text',
    show: 'showGoal4',
  },
  {
    date: 'goal5Date',
    text: 'goal5Text',
    show: 'showGoal5',
  },
]
export const validationSchema = yup.object().shape({
  classCreationGoalValue: yup
    .number()
    .nullable()
    .required('Number of classes is required')
    .min(1, 'Enter at least 1 class')
    .max(500, 'Cannot exceed 500 classes')
    .integer('Must be a whole number'),

  classCreationGoalDate: yup
    .date()
    .nullable()
    .required('Class creation goal date is required'),

  lessonCompletionGoalValue: yup
    .number()
    .nullable()
    .required('Lesson completion percentage is required')
    .min(1, 'Enter at least 1%')
    .max(100, 'Cannot exceed 100%')
    .integer('Must be a whole number'),

  lessonCompletionGoalDate: yup
    .date()
    .nullable()
    .required('Lesson completion goal date is required')
    .test(
      'is-after-class-creation',
      'Enter a date on or after class creation goal',
      function(value) {
        const { classCreationGoalDate } = this.parent
        if (!classCreationGoalDate || !value) return true

        const valueDate = value.toISOString().slice(0, 10)
        const creationDate = classCreationGoalDate.toISOString().slice(0, 10)

        return valueDate >= creationDate
      },
    ),

  showGoal3: yup.boolean(),
  goal3Date: yup
    .date()
    .nullable()
    .when('showGoal3', {
      is: true,
      then: schema =>
        schema
          .test('is-valid-date', 'Please select a date', value => {
            if (!value) return false
            const date = new Date(value)
            return !isNaN(date.getTime()) // valid date check
          })
          .nullable(),
      otherwise: schema => schema.notRequired(),
    }),
  goal3Text: yup
    .string()
    .nullable()
    .when('showGoal3', {
      is: true,
      then: schema =>
        schema
          .test(
            'not-empty',
            'Please enter a goal or select Remove',
            value => typeof value === 'string' && value.trim().length > 0,
          )
          .required(false)
          .max(256, 'Text is too long (maximum 256 characters)'),
      otherwise: schema => schema.notRequired(),
    }),
  showGoal4: yup.boolean(),
  goal4Date: yup
    .string()
    .nullable()
    .when('showGoal4', {
      is: true,
      then: schema =>
        schema.test('is-valid-date', 'Please select a date', value => {
          if (!value) return false
          const date = new Date(value)
          return !isNaN(date.getTime()) // valid date check
        }),
      otherwise: schema => schema.notRequired(),
    }),
  goal4Text: yup
    .string()
    .nullable()
    .when('showGoal4', {
      is: true,
      then: schema =>
        schema
          .test(
            'not-empty',
            'Please enter a goal or select Remove',
            value => typeof value === 'string' && value.trim().length > 0,
          )
          .required(false)
          .max(256, 'Text is too long (maximum 256 characters)'),
      otherwise: schema => schema.notRequired(),
    }),
  showGoal5: yup.boolean(),
  goal5Date: yup
    .string()
    .nullable()
    .when('showGoal5', {
      is: true,
      then: schema =>
        schema
          .test('is-valid-date', 'Please select a date', value => {
            if (!value) return false
            const date = new Date(value)
            return !isNaN(date.getTime()) // valid date check
          })
          .nullable(),
      otherwise: schema => schema.notRequired(),
    }),
  goal5Text: yup
    .string()
    .nullable()
    .when('showGoal5', {
      is: true,
      then: schema =>
        schema
          .test(
            'not-empty',
            'Please enter a goal or select Remove',
            value => typeof value === 'string' && value.trim().length > 0,
          )
          .required(false)
          .max(256, 'Text is too long (maximum 256 characters)'),
      otherwise: schema => schema.notRequired(),
    }),
})
